import React from 'react'


import { Link, useLocation } from 'react-router-dom';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import Plot from 'react-plotly.js';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';
import proj16_1 from '../../Images/anova_img1.png';
import './Project_16.css'

function Project_16() {

    const data = {
        labels: ['Promotion 3', 'Promotion 2', 'Promotion 1'],
        values: [188, 188, 172],
        type: 'pie',
        hole: 0.4,
      };
  
      const layout = {
        title: 'Promotion Distribution',
      };
//// Data for Count
      const data1 = [
        {
          x: ['Large', 'Medium', 'Small'],
          y: [56, 96, 20],
          type: 'bar',
          name: 'Promotion 1',
        },
        {
          x: ['Large', 'Medium', 'Small'],
          y: [64, 108, 16],
          type: 'bar',
          name: 'Promotion 2',
        },
        {
          x: ['Large', 'Medium', 'Small'],
          y: [48, 116, 24],
          type: 'bar',
          name: 'Promotion 3',
        },
      ];
      const layout1 = {
        title: 'Count of Sales by MarketSize and Promotion',
        xaxis: { title: 'MarketSize' },
        yaxis: { title: 'Count' },
        barmode: 'group',
      };

      const dataMean = [
        {
          x: ['Large', 'Medium', 'Small'],
          y: [75.24, 47.67, 60.16],
          type: 'bar',
          name: 'Promotion 1',
        },
        {
          x: ['Large', 'Medium', 'Small'],
          y: [60.32, 39.11, 50.81],
          type: 'bar',
          name: 'Promotion 2',
        },
        {
          x: ['Large', 'Medium', 'Small'],
          y: [77.20, 45.47, 59.51],
          type: 'bar',
          name: 'Promotion 3',
        },
      ];
    
      // Layout for mean sales
      const layoutMean = {
        title: 'Mean Sales by MarketSize and Promotion',
        xaxis: { title: 'MarketSize' },
        yaxis: { title: 'Mean Sales' },
        barmode: 'group',
      };
// Data for total sales
const dataTotalSales = [
    {
      x: ['Large', 'Medium', 'Small'],
      y: [4213.21, 4576.57, 1203.25],
      type: 'bar',
      name: 'Promotion 1',
    },
    {
      x: ['Large', 'Medium', 'Small'],
      y: [3860.61, 4224.35, 812.97],
      type: 'bar',
      name: 'Promotion 2',
    },
    {
      x: ['Large', 'Medium', 'Small'],
      y: [3705.79, 5274.39, 1428.34],
      type: 'bar',
      name: 'Promotion 3',
    },
  ];

  // Layout for total sales
  const layoutTotalSales = {
    title: 'Total Sales by MarketSize and Promotion',
    xaxis: { title: 'MarketSize' },
    yaxis: { title: 'Total Sales' },
    barmode: 'group',
  };
//Boxplot
const databox = [
    {
      y: [33.73, 35.67, 29.03, 39.25, 27.81, 34.67, 27.98, 27.72, 44.54, 37.94, 45.49, 34.75, 39.28, 39.8, 24.77, 30.98, 30.37, 24.82, 37.47, 23.35, 32.9, 22.18, 42.98, 26.68, 42.92, 42.16, 51.72, 36.17, 30.08, 28.62, 25.4, 27.26, 37.41, 38.64, 40.9, 41.11, 34.27, 29.3, 23.93, 35.16, 33.42, 37.93, 33.85, 40.25, 35.85, 36.24, 41.73, 37.32, 50.48, 36.88, 35.68, 46.45, 67.48, 65.57, 68.42, 60.93, 61.59, 63.64, 54.68, 61.24, 62.93, 58.77, 70.6, 65.06, 59.76, 66.11, 62.16, 64.04, 59.65, 57.04, 59.73, 56.72, 58.55, 62.19, 53.14, 62.27, 86.14, 82.56, 79.36, 77.17, 88.73, 85.21, 81.55, 94.17, 89.7, 78.43, 84.05, 81.18, 87.43, 81.79, 88.12, 75.29, 83.02, 90.3, 85.18, 89.77, 82.64, 82.89, 82.13, 88.91, 87.7, 81.16, 81.58, 94.21, 96.48, 84.13, 91.98, 81.72, 93.71, 96.01, 93.03, 97.61, 85.11, 88.07, 94.43, 89.44, 88.64, 81.37, 82.14, 79.64, 84.34, 87.9, 76.12, 82.72, 73.22, 75.88, 78.01, 80.17, 91.6, 80.61, 93.86, 83.43, 82.65, 77.39, 80.83, 80.75, 94.89, 74.75, 93.63, 80.82, 91.61, 79.02, 86.11, 82.88, 99.65, 88.64, 86.96, 89.25, 66.22, 82.86, 83.4, 75.61, 87.08, 89.32, 99.12, 85.85, 79.53, 74.03, 78.53, 76.71, 93.32, 85.71, 77.36, 91.29, 49.61, 43.69, 54.49, 61.25, 51.47, 53.47, 46.83, 56.7, 55.94, 61.36, 56.19, 62.06, 54.01, 63.48, 61.96, 55.3, 47.89, 52.37, 49.11, 52.88, 53.79, 66.96, 57.1, 65.12, 46.98, 53.41, 36.17, 55.98, 51.87, 58.01, 47.93, 51.33, 62.16, 54.06, 51.72, 59.64, 52.23, 51.68, 46.22, 46.03, 40.4, 50.28, 52.72, 38.3, 51.79, 42.56, 44.64, 45.11, 42.15, 42.59, 49.56, 39.25, 48.18, 48.25, 46.42, 43.77, 45.3, 48.84, 45.08, 44.67, 45.56, 55.19, 37.84, 50.07, 47.33, 45.42, 44.31, 40.26, 43.27, 48.33, 44.14, 51.5, 49.95, 55.11, 55.28, 54.7, 50.11, 55.59, 54.37, 51.91, 59.34, 62.63, 49.08, 58.04, 46.26, 47.71, 54.09, 46.89, 57.37, 55.53, 51.16, 57.06, 50.59, 48.64, 50.55, 49.08, 24.75, 41.47, 35.1, 34.33, 31.94, 29.64, 33.64, 36.05, 36.7, 41.53, 27.71, 37.2, 42.16, 36.8, 46.98, 47.35, 32.21, 38.41, 37.9, 44.84, 37.45, 35.46, 31.85, 19.26, 38.65, 17.34, 33.14, 23.44, 37.17, 30.52, 32.51, 29.12, 40.46, 41.25, 32.05, 47.5, 32.77, 30.26, 27.55, 27.37, 47.48, 39.41, 43.29, 42.59, 35.3, 35.86, 49.3, 30.81, 44.98, 41.71, 41.1, 40.97, 41.1, 41.56, 36.39, 39.67, 34.46, 40.13, 32.18, 43.73, 49.01, 46.29, 37.14, 42.82, 47.22, 35.24, 47.22, 43.15, 40.71, 38.26, 41.44, 25.7, 40.29, 48.35, 43.26, 44.2, 46.14, 41.12, 45.03, 38.85, 41.96, 42.27, 38.51, 43.51, 49.39, 40.25, 42.46, 31.62, 53.38, 55.31, 56.1, 43.24, 48.18, 43.11, 43.78, 56.9, 53.53, 47.92, 56.18, 46.66, 40.43, 51.15, 42.5, 52.76, 47.63, 52.21, 40.17, 48.36, 42.76, 50.52, 56.86, 47.51, 38.56, 37.29, 35.6, 33.35, 48.5, 36.8, 48.32, 41.54, 53.56, 49.72, 48.77, 46.84, 51.82, 45.02, 49.44, 51.32, 52.85, 40.84, 64.45, 44.43, 56.64, 46.06, 55.46, 51.41, 49.67, 49.98, 49.5, 47.35, 50.26, 52.05, 51.14, 46.3, 56.99, 45.57, 45.92, 50.52, 32.61, 57.27, 37.32, 41.22, 39.73, 50.3, 40.16, 41.37, 54.79, 52.39, 42.15, 49.63, 54.95, 55.78, 46.49, 56.84, 48.06, 51.09, 44.19, 49.52, 65.11, 54.38, 57.14, 49.91, 48.76, 44.14, 58.1, 44.16, 44.66, 53.78, 43.91, 52.41, 50.54, 58.43, 59.77, 60.44, 50.94, 49.38, 63.98, 45.84, 51.01, 56.16, 45.77, 46.47, 46.02, 51.09, 51.68, 55.91, 55.9, 59.8, 60.97, 64.14, 39.98, 54.58, 52.64, 45.43, 49.3, 61.8, 58.0, 55.2, 53.76, 39.36, 47.2, 53.66, 61.53, 59.17, 63.73, 61.77, 51.89, 51.17, 54.33, 50.05, 51.09, 54.82, 44.16, 53.95, 54.34, 60.24, 56.39, 58.33, 51.26, 51.73, 51.35, 41.85, 45.21, 55.02, 45.35, 47.06, 43.59, 46.03, 47.22, 51.41, 58.19, 62.72, 66.66, 64.66, 66.34, 60.59, 61.95, 67.84, 55.39, 49.16, 58.26, 48.12, 49.98, 44.84, 55.12, 47.36, 62.33, 53.68, 62.37, 63.58, 44.7, 43.44, 52.36, 45.9, 53.51, 49.76, 68.31, 66.1, 43.61, 46.2, 51.52, 49.71, 53.5, 56.34, 51.83, 50.2, 49.62, 62.54, 50.11, 61.63, 59.87, 62.99, 57.2, 64.34, 50.2, 45.75, 44.29, 49.41],
      type: 'box',
    },
  ];

  const layoutbox = {
    title: 'Box Plot of SalesInThousands',
    yaxis: { title: 'SalesInThousands' },
  };



    return (
        <div>
            <div className='outer_class'>

                <div className="text_box">

                    <div className='class_1'>
                        <h1>
                            Viraj Vhatkar
                        </h1>
                    </div>
                    <div className="inner_1_1">
                        <div className="inner_1_2">
                            <div className="_a_3">
                                <Link to="/projects" className='project-tag'>Strategy</Link>
                            </div>
                            <div className="_a_3">
                                <Link to="/projects" className='project-tag'>UIUX</Link>
                            </div>
                            <div class="_a_3">
                                <Link to="/projects" className='project-tag'>Ideation</Link>
                            </div>
                            <div class="_a_3">
                                <Link to="/projects" className='project-tag'>Brand Identity</Link>
                            </div>
                        </div>
                    </div>
                    <div className='project_name'>
                        <h2>
                            A/B_Testing
                        </h2>
                    </div>
                </div>




                <div className='project_content_101'>
                    <atrong>
                        A/B testing is a powerful technique used in marketing, product development, and website optimization to compare two or more versions of a webpage, app, or marketing campaign to determine which one performs better
                    </atrong>

                    <h3>Introducing a Delicious Dilemma: A Fast Food Chain's Quest for Marketing Brilliance</h3>
                    <div className='content'>

                        In the world of fast-food innovation, the sizzle of a new item on the menu isn't just about the taste; it's also about the tactics.
                        Picture this: a popular fast food chain stands at the crossroads, about to unleash a tantalizing new addition to its menu.
                        The aroma is captivating, the taste impeccable, but the question lingers - <strong>how can they market it in the most impactful way?</strong>
                        <br></br>  <br></br>
                        To solve this conundrum, the restaurant has embraced the task of finding out the output of marketing campaigns. For that reason,
                        let's embark on a journey through the art and science of<strong> A/B testing</strong> . We're about to transform the quest for culinary brilliance into a data-driven adventure. Picture three marketing campaigns vying for the limelight, each with its unique flavor of appeal. But which one will leave the most savory impression on the taste buds of the masses? To answer this tantalizing question,
                        a series of controlled experiments are already underway.
                    </div>
                    { /*<img src={patentimg} alt='image1' className='project_image_1' /> */}

                    <img src={proj16_1} alt='image1' className='project_image_1' />
                    The Project was made possible thanks to the dataset available on this <a href="https://rpubs.com/ksdwivedy/finalRProject">R-website</a>.
                    <br></br> <br></br> <br></br>
                  So lets understand what is A/B testing---> Lets say <strong>I'm </strong> i.e <strong>Viraj</strong> is the manger of a of a popular fast food chain. <br></br>
                    <br></br>
                    Now I've got a delicious new item ready to grace the menu, and my team is buzzing with excitement. However, here's the challenge: My team have  come up with three fantastic marketing campaigns to promote this scrumptious delight,
                    but we're in a bit of a conundrum. Which one is the magic recipe that will truly skyrocket our sales?
                    <br></br><br></br>
                    <strong>This is where A/B testing comes to the rescue: </strong>
                    <br></br>
                    • <strong>Version A (Campaign 1) </strong>     : This is my first marketing campaign, perhaps filled with catchy slogans and vibrant visuals.
                    <br></br>
                    • <strong>Version B (Campaign 2) </strong>  : The second campaign takes a different approach, using a unique selling proposition that sets it apart.
                    <br></br>
                    • <strong>Version C (Campaign 3)  </strong>  : And the third campaign brings its own flavor to the table, focusing on a completely different angle.
                    <br></br><br></br>

                    Now, we're ready to put these campaigns to the test. My team select a group of locations across various markets. To ensure fairness, they assign one campaign to each location. This way, they're not overwhelming one location with too many choices.
                    <br></br><br></br>
                    For the first four weeks, my team keep a close eye on the sales of our new item in each location, monitoring how each campaign is performing. Now they record the data meticulously, and this is where the magic of A/B testing happens.
                    <br></br><br></br>
                    After the test period, it's time for a data-driven analysis. We compare the results of each campaign in terms of sales, location performance, and other key metrics. We're not just interested in which campaign got the most sales, but why it performed well. Were there specific locations where one campaign shone? Did a particular channel, such as social media or email, play a significant role in driving sales?
                    <br></br><br></br>
                    This deep dive into the data allows us to predict which customers are more likely to respond to which campaign through which channel. We're not just guessing; we're basing our decisions on hard evidence.
                    <br></br><br></br>
                    And here's the icing on the cake: armed with this knowledge, we're well-prepared to fine-tune our future campaigns. we can increase the likelihood of responses and improve the quality of leads because we've learned what works and why. This means our marketing efforts become more efficient and more effective over time.
                    <br></br><br></br>
                    In a world where customers' tastes and preferences can change as quickly as the weather, A/B testing is <strong>the</strong> secret recipe to staying ahead in the game, ensuring our new item becomes a customer favorite, and our fast food chain thrives.
                    <br></br><br></br><br></br>
                    Now, let's dive into coding and unravel the narrative in a programming format.
                    <br></br><br></br>
                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`// Importing the Relevant Files
import pandas as pd
import numpy as np
import matplotlib.pyplot as plt
import seaborn as sns`}
                    </SyntaxHighlighter>
                    <h4>Exploratory Data Analysis (EDA) </h4>
                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`// Reading the File
df=pd.read_csv('C:/Users/viraj/Code_a/Machine_learning/AB_testting_Fast_food/WA_Mark.csv')
df
df.describe()`}
                    </SyntaxHighlighter>

                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter" style={{ fontSize: '12px' }}>
                        {`// Output
+-------+------------+-------------+-------------+------------+------+-------------------+
|       | MarketID   | LocationID  | AgeOfStore  | Promotion  | week | SalesInThousands  |
+-------+------------+-------------+-------------+------------+------+-------------------+
| count | 548        | 548         | 548         | 548        | 548  | 548               |
| mean  | 5.715328   | 479.656934  | 8.503650    | 2.029197   | 2.5  | 53.466204         |
| std   | 2.877001   | 287.973679  | 6.638345    | 0.810729   | 1.119| 16.755216         |
| min   | 1.0        | 1.0         | 1.0         | 1.0        | 1.0  | 17.34             |
| 25%   | 3.0        | 216.0       | 4.0         | 1.0        | 1.75 | 42.545            |
| 50%   | 6.0        | 504.0       | 7.0         | 2.0        | 2.5  | 50.2              |
| 75%   | 8.0        | 708.0       | 12.0        | 3.0        | 3.25 | 60.4775           |
| max   | 10.0       | 920.0       | 28.0        | 3.0        | 4.0  | 99.65             |
+-------+------------+-------------+-------------+------------+------+-------------------+
    `}
                    </SyntaxHighlighter>
                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`
df.info()
df.isnull().sum()
// The dataset has no-null value
print(df['Promotion'].value_counts())
//      Output:
                Promotion
                3    188
                2    188
                1    172
                Name: count, dtype: int64
//------------------------------
print(df['MarketSize'].value_counts())
//      Output:
                MarketSize
                Medium    320
                Large     168
                Small      60
                Name: count, dtype: int64

`}
                    </SyntaxHighlighter><br></br><br></br>
                    Lets Visualize about the data distribution
                    <br></br><br></br>
                    <Plot data={[data]} layout={layout} className='plott' />

                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`//  Calculating the mean sales by promotion and week
p1=df.groupby(['Promotion','week'])['SalesInThousands'].mean()
p1
//  Output:
                +-----------+-------+------------+
                | Promotion | Week  | Mean Sales |
                +-----------+-------+------------+
                |     1     |   1   |   58.24    |
                |           |   2   |   56.93    |
                |           |   3   |   58.77    |
                |           |   4   |   58.45    |
                +-----------+-------+------------+
                |     2     |   1   |   47.73    |
                |           |   2   |   47.58    |
                |           |   3   |   47.72    |
                |           |   4   |   46.28    |
                +-----------+-------+------------+
                |     3     |   1   |   55.78    |
                |           |   2   |   55.95    |
                |           |   3   |   54.38    |
                |           |   4   |   55.35    |
                +-----------+-------+------------+

`}
                    </SyntaxHighlighter><br></br>
                    Here, we could figure out that Promotion 1 generally performs better in terms of mean sales, while Promotion 2 tends to have the lowest mean sales figures. Promotion 3 falls in between these two extremes.
                    <br></br>

                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`// analyzing the Diffracture of Promotion and Marktersize
p2=df.groupby(["MarketSize","Promotion"]).agg({"SalesInThousands":["count", "mean", "sum"]})
p2
//  Output:
                +------------+------------+-------+---------+-------+
                | MarketSize | Promotion  | Count | Mean    | Sum   |
                +------------+------------+-------+---------+-------+
                | Large      | 1          | 56    | 75.24   | 4213.21 |
                |            | 2          | 64    | 60.32   | 3860.61 |
                |            | 3          | 48    | 77.20   | 3705.79 |
                +------------+------------+-------+---------+-------+
                | Medium     | 1          | 96    | 47.67   | 4576.57 |
                |            | 2          | 108   | 39.11   | 4224.35 |
                |            | 3          | 116   | 45.47   | 5274.39 |
                +------------+------------+-------+---------+-------+
                | Small      | 1          | 20    | 60.16   | 1203.25 |
                |            | 2          | 16    | 50.81   | 812.97  |
                |            | 3          | 24    | 59.51   | 1428.34 |
                +------------+------------+-------+---------+-------+
`}
                    </SyntaxHighlighter><br></br>
                    Larger markets tend to generate higher sales, while Promotion 1 displays variable performance across market sizes, excelling in smaller markets but not as much in medium-sized ones.
                    <br></br><br></br><br></br>
                    Let's present our findings in a more understandable and visually appealing manner.<br></br><br></br>
                    <Plot data={data1} layout={layout1} />
                    <Plot data={dataMean} layout={layoutMean} />
                    <Plot data={dataTotalSales} layout={layoutTotalSales} />
                    <Plot data={databox} layout={layoutbox} />

                    <br></br><br></br>


                    <h3>Hypothesis testing</h3>

                    <br></br>
1.)Does the type of promotion have a substantial impact on the sales of the new menu item?
                    <br></br><br></br>
                    <strong>Null Hypothesis (H0):</strong>
                    There is no statistically significant difference in the sales of the new menu item when different promotions are applied. In other words, the type of promotion does not affect sales.
                    <br></br><br></br>
                    <strong>Alternative Hypothesis (HA):</strong>
                    There is a statistically significant difference in the sales of the new menu item when different promotions are applied. In other words, the type of promotion significantly influences sales.
                    <br></br><br></br>
                    <strong>Significance Level (α):</strong>
                    For this analysis, we will use a significance level of 0.05, which implies that we are willing to accept a 5% chance of making a Type I error (incorrectly concluding a significant difference) if the null hypothesis is true.
                    <br></br><br></br>


                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`// importing Libraries
from scipy.stats import f_oneway
from statsmodels.stats.multicomp import pairwise_tukeyhsd
from scipy import stats
                            
np.random.seed(42)
df = df.sort_values(by='Promotion')
df = df.reset_index(drop=True)
promotiona = df[df['Promotion'] == 1]['SalesInThousands']
promotionb = df[df['Promotion'] == 2]['SalesInThousands']
promotionc = df[df['Promotion'] == 3]['SalesInThousands']
# Define the significance level
alpha = 0.05

# Perform one-way ANOVA test
fvalue, pvalue =stats.f_oneway(promotion1, promotionb, promotionc)

# Print the results
print("F-Value: ", fvalue)
print("P-Value: ", pvalue)

//      Output:
                F-Value:  21.953485793080684
                P-Value:  6.765849261408714e-10

`}

                    </SyntaxHighlighter>
                    <br></br>
                    Before applying Anova, make sure your data is sorted, as it's common prerequisite for conducting ANOVA.Basically you are ensuring that the data for each promtion is contiguous.Without sorting, the ANOVA may not correctly identify which data points belong to each group, leading to incorrect results.<br></br>
                    Here we are conducting one-way analysis of variance (ANOVA) test to determine whether there is a statistically significant difference in sales (SalesInThousands) for the new menu item among different promotions (Promotion levels 1, 2, and 3).
                    <br></br><br></br>
                    So based on the output we can state that there are statistically(p_value less than 00.5) significant differences in the sales of the new menu item among the different promotion levels (Promotion 1, Promotion 2, and Promotion 3).
                    <br></br><br></br>
                    So thus we could reject our NULL HYPOTHESIS(HO)
                    <br></br><br></br><br></br>
                    So our ANOVA TEST prove that there's a significant difference amoung groups, now lets shift our attention towards conducting the post-hoc tests to identify which specific group(s) differ from each other.

                    <br></br>


                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`# Perform post-hoc Tukey's HSD test
tukey_result = pairwise_tukeyhsd(df['SalesInThousands'], df['Promotion'])

# Print post-hoc test results
print(tukey_result)`}
                    </SyntaxHighlighter>

                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`// Output
-----------------------------------------------------
group1 group2 meandiff p-adj   lower    upper  reject
-----------------------------------------------------
     1      2 -10.7696    0.0 -14.7738 -6.7654   True
     1      3  -2.7345 0.2444  -6.7388  1.2697  False
     2      3   8.0351    0.0   4.1208 11.9493   True
-----------------------------------------------------

`}


                    </SyntaxHighlighter>
                    <br></br><br></br><br></br>
                    •The results indicate that there is a significant difference between group 1 and group 2. This is supported by a p-adjusted value of zero, and the confidence interval does not include 0.
                    <br></br>
                    • The results indicate that there is a significant difference between group 1 and group 3. This is supported by a p-adjusted value of zero, and the confidence interval does not include zero.
                    <br></br>
                    • And the last is group 2 and 3 where the results indicate that there is a significant difference between the groups.
                    <br></br><br></br>
                    Now after you conduct the Bonferroni Correction  the results are exactly similar to the above.
                    <br></br>
                    -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

                    <br></br><br></br><br></br>
                    2.)Is there a significant difference in sales between stores of different ages?
                    <br></br><br></br>
                    <strong>Null Hypothesis (H0):</strong>
                    There is no significant difference in sales between stores of different ages.<br></br><br></br>
                    <strong>Alternative Hypothesis (HA):</strong>
                    There is a significant difference in sales between stores of different ages.<br></br><br></br>
                    <strong>Significance Level (α):</strong>
                    For this analysis, we will use a significance level of 0.05, which implies that we are willing to accept a 5% chance of making a Type I error (incorrectly concluding a significant difference) if the null hypothesis is true.
                    <br></br><br></br>


                    <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                        {`from sklearn.linear_model import LinearRegression
from statsmodels.formula.api import ols
import statsmodels.api as sm
model = ols('SalesInThousands ~ C(AgeOfStore)', data=df).fit()

# Perform the ANOVA test
anova_table = sm.stats.anova_lm(model, typ=2)
print(anova_table)

//      Output:
                +---------------+-----------+-------+---------+-----------+
                |               |   sum_sq  |   df  |    F    |   PR(>F)  |
                +---------------+-----------+-------+---------+-----------+
                | C(AgeOfStore) | 18227.15  |  24.0 | 2.93491 | 0.000005  |
                | Residual      | 135336.13 | 523.0 |   NaN   |   NaN     |
                +---------------+-----------+-------+---------+-----------+

`}
                    </SyntaxHighlighter>
                    <br>
                    </br>
                    <br></br>
With small p-value (PR(>F) = 0.000005), which is well below the conventional significance level (0.05). and also the F-value(2.93491) also supports the significance.
                    <br></br>We can clearly conclude that we can REJECT our NULL HYPOTHESIS.
                    <br></br><br></br><br></br>
                    We can employ the Ordinary Least Squares (OLS) method to assess our previous hypothesis, specifically by modeling the relationship between "SalesInThousands" and "Promotion" categories.

                    <br></br><br></br><br></br>
                    Based on the above test, we can also formulate hypotheses related to "SalesInThousands" with respect to "MarketSize" (SalesInThousands ~ C(MarketSize)) and a more complex model involving "Promotion," "AgeOfStore," and their interaction (SalesInThousands ~ C(Promotion) + C(AgeOfStore) + C(Promotion):C(AgeOfStore). I have provided a detailed explanation of the code in my Jupyter Notebook.
                    <br></br><br></br><br></br>
Based on the above results Lets Cnduct Regression Analysis.Lets explore it in the next iteration.Till them do feel to add comment on linkedin for improvements.


                </div>
                <br>
                </br>
                <a className='box_1'> Next Project  </a>
                <Link to="/project_15" className='box_2'> Heart_Failure_Analytics</Link>
            </div>
        </div>
    )
}

export default Project_16